import { useCallback } from "react";
import { attributesByGroup } from "../lib/attribute-data";

export const useBuildSubgroups = () => {
    const IDENTIFYING_GROUP = "IntakeProfilingIdentifyingGroup";
    const DESCRIPTION_SUBGROUP = "ProfilingDescriptionInformation";
    const CATEGORY_SPECIFIC_SUBGROUP = "ProfilingCategorySpecificInformation";

    return useCallback((attributesSubGroups, isBrandVerified, parentGroupName) => {
        const brandVerifiedFilter =
            isBrandVerified && parentGroupName === IDENTIFYING_GROUP
                ? attributesSubGroups.filter((group) => group.groupName === DESCRIPTION_SUBGROUP || group.groupName === CATEGORY_SPECIFIC_SUBGROUP)
                : attributesSubGroups;

        return brandVerifiedFilter.reduce((groups, { subGroups, ...subGroupsParams }) => {
            const group = {
                ...subGroupsParams,
                subGroups: subGroups.map((subGroupChild) => {
                    return {
                        ...subGroupChild,
                        subGroups: attributesByGroup(subGroupChild.attributes),
                    };
                }),
            };

            return [...groups, group];
        }, []);
    }, []);
};
